"use client";

import ErrorPage from "@/ui/AppRouter/ErrorPage";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <ErrorPage
      error={error}
      reset={reset}
      title="Application error"
      description="A critical application error occurred. Please try refreshing the page."
    />
  );
}
